import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ORDER_LINK } from "../../constant/links";
import Header from "../Header/Header";
import styles from "./StaticHero.module.css";

const StaticHero = ({ title, subtitle, contact, details = "false" }) => {
  return (
    <div className="position-relative">
      <Header />
      <div
        className={styles.wrapper}
        style={{ minHeight: contact === true ? 580 : "auto" }}
      >
        <Container className="pt-5">
          <>
            <div className="">
              <Row className="mx-0">
                <Col md={12} className="pt-md-5 pt-0">
                  <h2 className={`text-white pb-4 text-center ${styles.title}`}>
                    {title}
                  </h2>
                  {details === true ? (
                    <Row>
                      <Col className="pb-5 mb-4 d-flex justify-content-center align-items-center">
                        <a
                          href={ORDER_LINK}
                          // to={`/order?type=${slug ? slug : ""}`}
                          target={"_blank"}
                          rel="noopener noreferrer"
                          className="btn_primary"
                        >
                          Order Now
                        </a>
                        {/* <Link to="/order" className={`btn_primary`}>
                          Order Now
                        </Link> */}
                      </Col>
                    </Row>
                  ) : (
                    <h2
                      className={`text-white pb-4 text-center ${styles.subtitle}`}
                    >
                      {subtitle}
                    </h2>
                  )}
                </Col>
              </Row>
            </div>
          </>
        </Container>
      </div>
    </div>
  );
};

export default StaticHero;
